export default __webpack_public_path__ + "static/media/logo.561522df.png";